import router from "./router";
import store from "./store/index";

export default router.beforeEach((to, from, next) => {
    let auth = store.getters.auth.routes
    if (to.meta.requireAuth) {
        if (auth.some(item => item.resCode == "authority_server")) {
            next()
        } else {
            router.push('404')
        }
    } else {
        next()
    }
})
